import {
    deleteImageRequest,
    deleteImagesRequest,
    uploadFileRequest,
    getImagesRequest,
} from '../../../services/network/common/upload';

class CommonUploadFileService {
    async uploadFile(payload) {
        return await uploadFileRequest(payload);
    }

    async deleteImage(payload) {
        return await deleteImageRequest(payload);
    }

    async deleteImages(payload) {
        return await deleteImagesRequest(payload);
    }

    async getImages(payload) {
        return await getImagesRequest(payload);
    }
}

export const UploadFileService = new CommonUploadFileService();
